import React, { Component } from 'react';
import Conrols from '../../util/controls';
import { browserHistory } from 'react-router';
import Moment from 'moment';

class JobDetails extends Component {

    constructor(props) {
        super(props);
        this.giveFeedback = this.giveFeedback.bind(this);
    }

    giveFeedback(jobId) {
        browserHistory.push(`/survey/${jobId}`);
    }

    render() {
        let { details } = this.props;

        return (
            <div>
                {
                    details ?
                        <div>
                            <h3 className="client-text">Job Details </h3>
                            <div className="card no-bottom">
                                <table className="table table-striped m-b-0">
                                    <tbody>
                                        <tr>
                                            <th>Job ID</th>
                                            <td>{details.jobID}</td>
                                        </tr>
                                        <tr>
                                            <th>Job Type</th>
                                            <td>{details.jobType}</td>
                                        </tr>
                                        <tr>
                                            <th>Status</th>
                                            <td>{details.status}</td>
                                        </tr>
                                        <tr>
                                            <th>Device Type</th>
                                            <td>{details.deviceType}</td>
                                        </tr>
                                        <tr>
                                            <th>Logged</th>
                                            <td>{Moment(details.loggedDateTime).format('DD MMM YYYY')}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h3 className="client-text">Contact Details </h3>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card text-center">
                                        <address>
                                            <i className="fa fa-map-marker" /> <strong>{details.name}</strong><br />
                                            {details.address}<br />
                                            {(details.address2 || "").trim() ? (
                                                <span>{details.address2}<br /></span>
                                            ) : null}
                                            {details.city}, {details.state}, {details.postcode}
                                        </address>
                                    </div>
                                </div>
                            </div>

                            {
                                details.status == 'closed' ?
                                    <button onClick={this.giveFeedback.bind(this, details.jobID)} className="btn btn-client btn-lg btn-block">
                                        <i className="fa fa-star" /> Provide Feedback
                                </button> :
                                    null
                            }
                        </div>
                        :
                        <Conrols.LoadingPanel />
                }
            </div>
        );
    }
}

export default JobDetails;


// WEBPACK FOOTER //
// ./app/jobs/components/jobDetails.js